import React from 'react'
import { Button } from './Button'
import { Profile, Task } from '../../lib/types/database.types'
import { isAssignableTaskCapabilityProfile } from '../../lib/config/role-config'

interface AssignTaskModalProps {
  task: Task | null
  profiles: Profile[]
  selectedAssignee: string
  onSelectedAssigneeChange: (value: string) => void
  onClose: () => void
  onAssign: () => void
  isLoading?: boolean
  error?: string | null
}

export const AssignTaskModal: React.FC<AssignTaskModalProps> = ({
  task,
  profiles,
  selectedAssignee,
  onSelectedAssigneeChange,
  onClose,
  onAssign,
  isLoading = false,
  error,
}) => {
  if (!task) {
    return null
  }

  const assignableProfiles = profiles.filter((profile) => isAssignableTaskCapabilityProfile(profile))

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900/50 p-4">
      <div className="w-full max-w-md rounded-xl border border-stone-300 bg-stone-100 shadow-xl">
        <div className="flex items-center justify-between border-b border-stone-300 px-6 py-4">
          <div>
            <h2 className="text-lg font-semibold text-gray-900">Assign Task</h2>
            <p className="text-sm text-gray-500">Choose who should own this task.</p>
          </div>
          <button type="button" className="text-gray-500 hover:text-gray-700" onClick={onClose}>
            Close
          </button>
        </div>

        <div className="space-y-4 px-6 py-5">
          <div>
            <p className="text-sm font-medium text-gray-900">{task.title}</p>
          </div>

          {error && <div className="rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-700">{error}</div>}

          <label className="space-y-2">
            <span className="text-sm font-medium text-gray-700">Assignee</span>
            <select
              className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm"
              value={selectedAssignee}
              onChange={(event) => onSelectedAssigneeChange(event.target.value)}
            >
              <option value="">Select a user</option>
              {assignableProfiles.map((profile) => (
                <option key={profile.id} value={profile.id}>
                  {profile.full_name || profile.email || 'Unknown user'}
                </option>
              ))}
            </select>
          </label>

          <div className="flex justify-end gap-3 border-t border-stone-300 pt-4">
            <Button type="button" variant="ghost" onClick={onClose}>
              Cancel
            </Button>
            <Button type="button" onClick={onAssign} isLoading={isLoading} disabled={!selectedAssignee}>
              Assign
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}